export const STATE_SEARCH_QUERY = "search-query";
export const STATE_AUTH_DESTINATION = "auth-destination";
